"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintBridgeService = void 0;
var _printBridge = require("../controllers/printBridge.controller");
var PrintBridgeService = {
  site: {
    fetch: _printBridge.config.site,
    update: _printBridge.config.site,
    preview: _printBridge.config.printBridge + "/preview/site",
    download: _printBridge.config.printBridge + "/generate-pdf/site",
    delete: _printBridge.config.site,
    softDelete: _printBridge.config.site + "/delete/soft",
    softDeleteRestore: _printBridge.config.site + "/delete/soft/restore",
    softDeletedList: _printBridge.config.site + "/list/soft/deleted",
    bulkSoftDelete: _printBridge.config.sitePb + "/bulk/site/delete/soft",
    bulkHardDelete: _printBridge.config.sitePb + "/bulk/site/delete/hard",
    bulkRestore: _printBridge.config.sitePb + "/bulk/site/delete/soft/restore"
  },
  report: {
    fetch: _printBridge.config.report,
    update: _printBridge.config.report,
    preview: _printBridge.config.printBridge + "/preview/report",
    download: _printBridge.config.printBridge + "/generate-pdf/report",
    pdfFetch: _printBridge.config.reportUpdatePb,
    delete: _printBridge.config.reportPb,
    softDelete: _printBridge.config.reportPb + "/delete/soft",
    softDeleteRestore: _printBridge.config.reportPb + "/delete/soft/restore",
    softDeletedList: _printBridge.config.reportPb + "/list/soft/deleted",
    bulkSoftDelete: _printBridge.config.reportPb + "/bulk/delete/soft",
    bulkHardDelete: _printBridge.config.reportPb + "/bulk/delete/hard",
    bulkRestore: _printBridge.config.reportPb + "/bulk/delete/soft/restore"
  },
  survey: {
    preview: _printBridge.config.printBridge + "/preview/survey",
    download: _printBridge.config.printBridge + "/generate-pdf/survey"
  },
  contentPanel: {
    preview: _printBridge.config.printBridge + "/preview/content-panel",
    download: _printBridge.config.printBridge + "/generate-pdf/content-panel"
  },
  palette: {
    list: _printBridge.config.printBridge + "/palette/list"
  }
};
exports.PrintBridgeService = PrintBridgeService;